import type { IProductService } from './productService.js';

export function commerceAllowed(product: IProductService): boolean {
    return product.commerceEnabled !== false;
}

export function cloudChatAllowed(product: IProductService): boolean {
    return product.cloudChatEnabled !== false;
}

export function entitlementNotice(signedIn: boolean): string {
    const message = signedIn
        ? 'This feature requires Needle Inspector Pro or Needle Engine Pro. Your account does not include either.'
        : 'Sign in with an account that includes Needle Inspector Pro or Needle Engine Pro to use this feature.';
    return `${message} [Documentation](https://needle.click/inspector-chatgpt)`;
}

export function mcpEntitlementResponse(product: IProductService, signedIn: boolean): { error: string; instructions: string } {
    if (commerceAllowed(product)) throw new Error('MCP entitlement response is only for commerce-free products');
    return {
        error: entitlementNotice(signedIn),
        instructions: signedIn
            ? 'This account does not currently include this feature.'
            : 'Sign in with an account that already includes this feature.',
    };
}

export function aiUsageLimitNotice(product: IProductService, teamName: string): string {
    const subject = teamName ? `Your team (${teamName})` : 'Your team';
    const text = `${subject} has reached its monthly AI usage limit. Please try again later`;
    return commerceAllowed(product)
        ? `${text} or [upgrade your plan](${product.needleCloudUrl ?? 'https://cloud.needle.tools'}/team).`
        : `${text}.`;
}

export function aiAuthRecoveryNotice(product: IProductService): string {
    return commerceAllowed(product)
        ? 'Authentication failed. If you just signed in or bought a license, click Reconnect — otherwise sign out and back in.'
        : 'Authentication failed. If you just signed in, click Reconnect — otherwise sign out and back in.';
}
